__turbopack_context__.v({
  "bio": "ExpandableBio-module-scss-module__Z5dBwW__bio",
  "bioContent": "ExpandableBio-module-scss-module__Z5dBwW__bioContent",
  "bioContentCollapsed": "ExpandableBio-module-scss-module__Z5dBwW__bioContentCollapsed",
  "readMore": "ExpandableBio-module-scss-module__Z5dBwW__readMore",
});
